module.exports = __webpack_public_path__ + "static/media/New_Brunswick_Canada_Logo_Watermark.788116f0.svg";